const userInfoMessages = {
  'userInfo.title': '情報',
  'userInfo.userInfo.title.companyCode': '企業コード',
  'userInfo.userInfo.title.userId': 'ログインID',
  'userInfo.userInfo.title.role': '権限',
};

export default userInfoMessages;
